import React from "react";
import { Badge, IconBox, detailLabelStyle, detailTdStyle, isEmpty, show } from "./DetailUI";

// Building blocks of the Profile-style detail layout (profile, supplier and agency detail pages):
// one card, each category has an icon heading and a compact open label/value grid.

// table cells use the same type as the field values (13.5px, semi-bold, dark)
export const profileTdStyle = { ...detailTdStyle, fontSize: 13.5, fontWeight: 600, color: "#0f172a" };

// category heading + content; stack several inside a card body that has pt-0
export const ProfileSection = ({ icon, title, subtitle, accent, children }) => (
  <div className="mt-4">
    <div className="d-flex align-items-center gap-2 pb-2 mb-3" style={{ borderBottom: `2px solid ${accent}26` }}>
      <IconBox icon={icon} accent={accent} size={26} />
      <span className="fw-bold" style={{ fontSize: 14, color: "#0f172a" }}>{title}</span>
      {subtitle && <span style={{ fontSize: 11.5, color: "#94a3b8" }}>{subtitle}</span>}
    </div>
    {children}
  </div>
);

// items: [{ label, value, badge?, full? }]
export const ProfileFields = ({ items }) => (
  <div className="row g-3">
    {items.map((f) => (
      <div key={f.label} className={f.full ? "col-12" : "col-6 col-md-4 col-xl-3"}>
        <div style={detailLabelStyle}>{f.label}</div>
        <div style={{ fontSize: 13.5, fontWeight: 600, color: isEmpty(f.value) ? "#cbd5e1" : "#0f172a", wordBreak: "break-word" }}>
          {f.badge ? <Badge value={f.value} /> : show(f.value)}
        </div>
      </div>
    ))}
  </div>
);
